<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ch-title"><a id="page_6"></a><a id="page_7"></a><a id="Acknowledgements"><b>Acknowledgements</b></a></h1><a id="Acknowledgements">
<p class="noindent"><span class="dropcap"><img alt="images" src="images/p007-001.jpg"/></span> would like to thank the staff at Sheffield Local Studies Library for the access to newspaper archives and for permission to use historic photographs from the Picture Sheffield collection. I would also like to thank David Clifford Taylor for his knowledge of many unsolved murders which helped me identify some of the cases featured in this book and proved to be a useful starting point in my research. I would like to thank my wife for her support and for accompanying me on some very long walks across South Yorkshire to take photographs and carry out research.</p>
<p class="para">Finally I would like to thank Sue Blackhall, Lisa Hooson and all of the staff at Pen and Sword Books who have assisted in the production of this book.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?38fd6c38